
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import contactService from './contactService';
import Pagination from 'components/Common/newPagination';
import { ImprintFom } from '../Imprint/imprintForm';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import LabelServices from 'components/Imprint/LabelServices';
import { CommonUtilities } from 'commonUtils';

export function SelectContact(param: any) {

    let [search, setSearch] = useState("");
    let [showTab, setShowTab] = useState(1);
    let [totalRow, inittotalRow] = useState(0);
    let [contactList, initcontactList] = useState<any[]>([]);
    let [imprintList, initimprintList] = useState<any[]>([]);
    let [totalRowImprint, inittotalRowImprint] = useState(0);
    let [emptyContact, setemptyContact] = React.useState(false);
    let [contactListPage, initcontactListPage] = useState<any[]>([]);

    console.log(param)
    useEffect(() => {
        search = param?.data?.contractArtist
        setSearch(search)
        Search();
    }, [param.data]);

    const searchField = (e: any) => {

    }

    var pagination = {
        'pageSize': 10,
        'pageNumber': 1
    }

    const Search = () => {
        console.log(search)

        contactService.SelectContact({ "contactNameOrCode": search, "digitalOnly": "null" }).then((res) => {
            console.log(res);
            console.log(contactList);
            contactList = res
            initcontactList(res);
            pagination.pageNumber = 1;
            paginationContacts(pagination);
        })

        if (search?.length > 0) {

        } else {
            setemptyContact(true)
            setTimeout(function () {
                setemptyContact(false)
            }, 5000);

        }

    }

    const paginationContacts = (e: any) => {
        console.log(e);
        pagination.pageNumber = Number(parseInt(e.pageNumber)) > 0 ? Number(parseInt(e.pageNumber)) : 1;
        pagination.pageSize = Number(parseInt(e.pageSize));

        var contactListPG = contactList;

        console.log(((pagination.pageNumber - 1) * pagination.pageSize));
        console.log((((pagination.pageNumber - 1) * pagination.pageSize) + pagination.pageSize));

        contactListPage = contactListPG?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        initcontactListPage(contactListPage);

    }


    const handleNameOnChange = (n: any) => {
        console.log(n);
        //contactList = contactListPag.slice((n.pageNumber - 1 ) * n.pageSize ,(n.pageSize *n.pageNumber  ))   
        //initcontactList(contactList)  
    }

    var data = {
        "pageSize": 10,
        "pageNumber": 1
    }
    const handleNameOnChangeImprint = (n: any) => {
        data.pageNumber = n.pageNumber;
        data.pageSize = n.pageSize;
        api();
    }
    const api = () => {

        contactService.kontactCompanyInfo({ "imprint": "label", "pageNumber": data.pageNumber, "pageSize": data.pageSize }).then((res) => {
            initimprintList(res);
            inittotalRowImprint(res[0].totalRows ? res[0].totalRows : 0)
        })
    }

    const SelectContactName = (n: any) => {
        console.log(n)
        var tempType = "";
        //tempType = showTab==1?"kontact" : "Imprint"
        param.SelectContactImprint({ data: n, type: tempType })
    }

    const closeContactForm = () => {
        param.SelectContactImprint("close")
    }

    let [imprintUpsrt, setImprintUpsert] = useState(false)
    const onChangeImprint = (e: any) => {
        imprintUpsrt = false;
        setImprintUpsert(imprintUpsrt)
    }


    let [deleteImprint, setdeleteImprint] = useState(false);
    let [deleteImprintSelect, setdeleteImprintSelect] = useState<any>([]);

    const Confirmation = (e: any) => {
        console.log(e)
        console.log(deleteImprintSelect)
        if (e === 1) {
            LabelServices.kontactCompanyInfoDelete(deleteImprintSelect.id).then((respond) => {
                if (respond) {

                    LabelServices.kontactImprintTypeDelete(deleteImprintSelect.imprintId).then((respond) => {
                        CommonUtilities.showToastDawer('Row Deleted', 'Success')
                    })
                }
            })


        }
        deleteImprint = false
        setdeleteImprint(deleteImprint)
    }

    return (
        <>

            <Drawer
                open={param.open}
                onClose={closeContactForm}
                direction='right'
                className='react-drawer-left full-height-vh ' style={{ width: "100%" }}>

                <div className="ws-8 box pull-right box landing allowHscroll allowVscroll" style={{ height: "100%" }}>

                    <div className="box-header-main ws-12">
                        <h2>Search Contact Form</h2>
                    </div>

                    <div className="ws-12 box-content ">
                        {!param.hideTab && <ul className="nav nav-tabs pm">
                            <li className={showTab == 1 ? "btn btn-l btn-info active" : "btn-white"} onClick={() => setShowTab(1)}><a>Contact</a></li>
                            <li className={showTab == 2 ? "btn btn-l btn-info active" : "btn-white"} onClick={() => { setShowTab(2); api() }}><a>Imprint</a></li>

                        </ul>}

                        {showTab == 1 && <div className="ws-12">

                            <div className="ws-12 pll">

                                <div className="ws-6 pull-left">
                                    <button className="icon-btn edit width100 height35 pull-right" onClick={Search}>Search </button>
                                    <input type="text" className="ws-9 m0 heightReset noBorderRadius" name="contactNameOrCode" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Enter Contact Code/Display/Name" id="contact.code" />
                                </div>

                                <div className="ws-6 hide">

                                    <div className="form-format ws-2 mtxl hide">
                                        <label>Creator</label>
                                        <label className="switch">
                                            <input type="checkbox" name="creator" onChange={(e) => searchField(e)} />
                                            <span className="slider round text-left white pm pts" >Yes</span>
                                            <span className="slider round text-right white pm pts sliderOff hide">No</span>
                                        </label>
                                    </div>

                                    <div className="form-format ws-1 mtxl hide">
                                        <label className="control-label"></label>
                                        <div className="label-entries">
                                            <input type="radio" value="null" name="digitalOnly" onChange={(e) => searchField(e)} />All
                                        </div>
                                    </div>

                                    <div className="form-format ws-3 mtxl hide">

                                        <label className="control-label" ></label>
                                        <div className="label-entries ">
                                            <input type="radio" value="true" name="digitalOnly" onChange={(e) => searchField(e)} />Digital Provider Only
                                        </div>

                                    </div>

                                    <div className="form-format ws-3 mtxl hide">
                                        <label className="control-label"></label>
                                        <div className="label-entries ">
                                            <input type="radio" value="false" name="digitalOnly" />Non digital Provider
                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div className="ws-12 mtl pll">
                                <div className="ws-12"><h2>Showing <span className="info">{contactList.length}</span> results</h2></div>

                                <div className="alert alert-success  hide" > Contact  has been deleted successfully</div>

                                {(contactList.length > 0) && <div className="table-responsive">
                                    <table className="  NewTable">
                                        <thead>
                                            <tr>
                                                <th>Contact code</th>
                                                <th>Contact display</th>
                                                <th>Contact name</th>
                                                <th style={{ width: 150 }}>Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                contactListPage.map((data) => {
                                                    return (
                                                        <tr >
                                                            <td width='150'> {data.kontactCode} </td>
                                                            <td> {data.kontactDisplay} </td>
                                                            <td> {data.kontactName} </td>
                                                            <td width='150'>
                                                                <button className="icon-btn info" onClick={() => SelectContactName(data)}> <i className="icon-tick1"></i></button>
                                                                <button className="icon-btn edit hide" onClick={() => SelectContactName(data)}> <i className="icon-edit"></i></button>
                                                                <button className="icon-btn delete hide" onClick={() => SelectContactName(data)}> <i className="icon-close"></i></button>
                                                            </td>
                                                        </tr>)
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>}

                                <div className="ws-12 pt mtl">
                                    {
                                        (() => {
                                            if (contactList.length > 10) {
                                                return <Pagination onPageChange={paginationContacts} totalRow={contactList.length} />
                                            }
                                        })()
                                    }</div>

                            </div>

                        </div>}

                        {showTab == 2 && <div className="ws-12">

                            <div className='ws-12 box'>

                                <div className="ps box-header">
                                    <h2>Hierarchy of Record Label(s) </h2>
                                </div>

                                <div className="ws-12 pLarge ">

                                    <div className="ws-12">
                                        <div className="form-format ws-4">
                                            <label className="control-label" >Sequence</label>
                                            <div className="label-entries">
                                                <input type="text" name="sequence" placeholder="Enter Sequence" />

                                            </div>
                                        </div>

                                        <div className="form-format ws-4">
                                            <label className="control-label" >Name</label>
                                            <div className="label-entries">
                                                <input type="text" name="companyName" placeholder="Enter Name" />

                                            </div>
                                        </div>
                                        <div className="form-format ws-4" ng-show="codeR || true">
                                            <label className="control-label" >Code</label>
                                            <div className="label-entries">
                                                <input type="text" name="code" placeholder="Enter Code" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pull-right ptl pbl">
                                        <button className="btn icon-btn edit width100 height35" onClick={api}> Search</button>
                                        <div className='ws-2'></div>
                                        <button className="btn icon-btn edit width100 height35" onClick={() => setImprintUpsert(true)}> Add </button>

                                    </div>

                                </div>

                            </div>

                            <div className='ws-12 mtl'>

                                {totalRowImprint > 0 && <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th>Sequence</th>
                                            <th>Name</th>
                                            <th>Code</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            imprintList.map((data) => {
                                                return (
                                                    <tr >

                                                        <td >{data.imprintSequence}</td>
                                                        <td >{data.companyName}</td>
                                                        <td >{data.code}</td>
                                                        <td >   <button type="button" className="icon-btn edit block">{data.step} </button> </td>
                                                        <td >
                                                            <button className="icon-btn info width90" onClick={() => SelectContactName(data)}><i className="icon-tick"></i> Select</button>
                                                            <button className="icon-btn edit mbs width90" onClick={() => setImprintUpsert(true)}><i className="icon-edit1"></i> Edit</button>
                                                            <button className="icon-btn delete width90" onClick={() => { setdeleteImprintSelect(data); setdeleteImprint(true) }}><i className="icon-close"></i> Delete</button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }


                                    </tbody>
                                </table>}

                            </div>

                            <div className="box" >
                                {
                                    (() => {
                                        if (totalRowImprint && totalRowImprint > 10) {
                                            return <Pagination onPageChange={handleNameOnChangeImprint} totalRow={totalRowImprint} />
                                        }
                                    })()
                                }
                            </div>

                        </div>}

                        {(contactList.length === 0) && showTab == 1 && <div className="alert alert-info ws-12 " >No records to display</div>}

                        {(totalRowImprint === 0) && showTab == 2 && <div className="alert mtl" >No data to display</div>}
                    </div>


                    <div className="box-footer">
                        <button className="icon-btn delete btn-sm" onClick={closeContactForm}>
                            <i className="fa fa-close"></i> Close
                        </button>
                    </div>

                    {(() => {

                        if (imprintUpsrt) {
                            return <ImprintFom data={param.data} imprintUpsrt={imprintUpsrt} onChangeImprint={onChangeImprint} />
                        }

                        if (deleteImprint) {
                            return <DeleteDialogueBox param={true} message={"delete the selected record "} onChange={Confirmation} />
                        }

                    })()}

                </div>

            </Drawer >
        </>
    )
}